import { Record } from 'immutable';

export const UserRecord = Record({
  id: null,
  givenName: '',
  familyName: '',
  emailAddress: '',
  phoneNumber: '',
});

UserRecord.parse = (user) => {
  const { id, givenName, familyName, emails, phones } = user;

  return new UserRecord({
    id,
    givenName,
    familyName,
    emailAddress: emails[0].emailAddress ? emails[0].emailAddress : '',
    phoneNumber: phones[0].phoneNumber ? phones[0].phoneNumber : '',
  });
};
